/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { noop } from 'lodash';

import { FileListItem, FilePicker } from './file-container.interfaces';

export interface FileInputChangeEvent {
  source: FileInputDirective;
  value: FileListItem[];
}

@Directive({
  standalone: false,
  selector: '[ghFileInput]',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: FileInputDirective, multi: true }],
})
export class FileInputDirective implements ControlValueAccessor {
  @Output() selectionChange = new EventEmitter<FileInputChangeEvent>();

  files: FileListItem[] = [];

  private onChange = noop;
  private onTouched = noop;

  @Input('ghFileInput')
  set picker(picker: FilePicker) {
    if (picker) {
      picker.registerOnSelected(this.onSelected.bind(this));
    }
  }

  @Input()
  set value(files: FileListItem[]) {
    this.setFiles(files);
  }

  constructor(private elementRef: ElementRef) {
  }

  onSelected(newFiles: FileListItem[]): void {
    this.setFiles(newFiles);
    this.onTouched();
  }

  writeValue(files: any): void {
    this.setFiles(files || []);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.elementRef.nativeElement.disabled = isDisabled;
  }

  private setFiles(files: FileListItem[]): void {
    this.files = files;
    this.onChange(files);

    this.elementRef.nativeElement.value = files.map((file) => file.name).join(', ');
  }
}
